import type { Patient } from "fhir/r5";
import {
  getPatientCpfKey,
  getPersonCpfDigits,
  getPersonDisplayName,
  getPersonPhone,
} from "./ecommercePersonDisplay";
import {
  getPatientDisplayName,
  getPatientPhone,
} from "../transformers/wooFormatters";
import { getEcommercePatientKey } from "./patientSearch";

export type EcommercePeopleRow = {
  key: string;
  name: string;
  cpf: string;
  phone: string;
  /** Cliente cadastrado que também tem paciente com consentimento. */
  hasConsent: boolean;
  canManage: boolean;
  patient?: Patient;
  person?: fhir5.Person;
};

export function buildConsentPatientRows(
  patients: Patient[],
): EcommercePeopleRow[] {
  return patients.map((patient) => {
    const cpf = getPatientCpfKey(patient);
    return {
      key: `consent:${getEcommercePatientKey(patient)}`,
      name: getPatientDisplayName(patient),
      cpf,
      phone: getPatientPhone(patient),
      hasConsent: true,
      canManage: true,
      patient,
    };
  });
}

export function buildRegisteredClientRows(
  persons: fhir5.Person[],
  consentCpfs: Set<string>,
): EcommercePeopleRow[] {
  return persons.map((person) => {
    const cpf = getPersonCpfDigits(person);
    return {
      key: `client:${person.id || cpf}`,
      name: getPersonDisplayName(person),
      cpf,
      phone: getPersonPhone(person),
      hasConsent: Boolean(cpf && consentCpfs.has(cpf)),
      canManage: false,
      person,
    };
  });
}

export function matchesPeopleRowSearch(
  row: EcommercePeopleRow,
  rawTerm: string,
): boolean {
  const term = rawTerm.trim().toLowerCase();
  if (!term) return true;
  const termDigits = term.replace(/\D/g, "");
  const matchesName = row.name.toLowerCase().includes(term);
  const matchesCpf =
    termDigits.length > 0 && row.cpf.replace(/\D/g, "").includes(termDigits);
  return matchesName || matchesCpf;
}
